// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// Types
import { GridColDef } from "@mui/x-data-grid-pro";
import { ClassNameHints } from "@Common/types/tables";
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";

type TUnitsOnLotTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

const columns: (GridColDef & { hints?: Partial<ClassNameHints> })[] = [
	{
		field: "_id",
		headerName: "ID",
	},
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },
	{
		field: "name",
		headerName: "Lot/Address",
	},
	{
		field: "manuallyReconciled",
		headerName: "",
		editable: true,
	},
	{
		field: "vinNumber",
		headerName: "VIN",
	},
	{
		field: "year",
		headerName: "Year",
		type: "number",
		headerAlign: "right",
		align: "right",
		width: 60,
	},
	{
		field: "make",
		headerName: "Make",
		width: 90,
	},
	{
		field: "model",
		headerName: "Model",
	},
	{
		field: "color",
		headerName: "Color",
	},
	{
		field: "stockNumber",
		headerName: "Stock #",
	},
	{
		field: "balance",
		headerName: "Balance",
		align: "right",
		type: "number",
		hints: { isMoney: true, noFocus: true, noWrap: true },
	},
	{
		field: "reason",
		headerName: "Reason",
		width: 140,
		editable: true,
	},
	{
		field: "resolution",
		headerName: "Resolution",
		width: 140,
		editable: true,
	},
	{
		field: "notes",
		headerName: "Notes",
		headerAlign: "right",
		align: "right",
		width: 80,
		editable: true,
	},
];

export default function UnitsOnLotTable(props: TUnitsOnLotTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;
	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="unitsOnLot"
		/>
	);
}
